<ion-app has-bouncing="false" overflow-scroll="false" scrollY="false">
    <div class="universal-bg ion-project-wrapper">
        <div class="d-none d-lg-block sticky-top">
            <bh-desktop-header></bh-desktop-header>
        </div>

        <div class="d-flex h-100 universal-bg">
            <div id="lg-sidebar" [ngClass]="this.systemService.minimizedSideBar ? 'sidebar-width-lg min' : 'sidebar-width-lg'" style="height: fit-content; background-color: #f4f6fa" *ngIf="showTabsAndSideBar && rightPageToShowSidebar">
                <img (click)="toggleSidePanelInLG()" src="assets/icon/back.svg" alt="back" [ngClass]="this.systemService.minimizedSideBar ? 'open toggle-img cursor-pointer' : 'toggle-img cursor-pointer'" class="d-none d-lg-inline" />
                <div class="desktop-side-panel d-none d-md-none d-lg-block">
                    <bh-side-panel [sideMenuItems]="sideMenuItems"></bh-side-panel>
                </div>
            </div>
            <div class="app-router-outlet universal-bg hide-scrollbar" [ngClass]="{ 'pre-transaction': !rightPageToShowSidebar, 'no-calc-height': !rightPageToShowSidebar, 'mx-5': this.systemService.minimizedSideBar, 'full-width-outlet w-100 mx-lg-0': this.systemService.minimizedSideBar }">
                <router-outlet></router-outlet>
            </div>
        </div>

        <!-- landscape error div start -->
        <div id="error-div" class="hide-modal">
            <div class="container-fluid rotate-img-center-div-container">
                <div class="rotate-img-center-div">
                    <div class="row p-3">
                        <div class="col-2 d-none d-lg-block"></div>
                        <div class="col-12 col-lg-8">
                            <div class="row p-lg-5">
                                <div class="col-2 col-sm-3"></div>
                                <div class="d-flex justify-content-center align-items-center col-8 col-sm-6 text-center p-0">
                                    <img class="rotate-img-cls" src="assets/icon/mobile-portrait-mode-icon.svg" />
                                </div>
                                <div class="col-2 col-sm-3"></div>
                            </div>
                        </div>
                        <div class="col-2 d-none d-lg-block"></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- landscape error div end -->
        <bh-no-internet *ngIf="isOffline"></bh-no-internet>
        <app-under-maintenance *ngIf="this.systemService.underMaintenance"></app-under-maintenance>
        <div class="footer-desktop d-none d-lg-block" *ngIf="!hideFooter">
            <bh-desktop-footer></bh-desktop-footer>
        </div>
        <modal-pop-up [showCloseBtn]="!isMajorUpdate" *ngIf="this.showModal" (onTogglePopUp)="closeModal()">
            <ion-text class="font-20 m-0 weight-700" color="primary">Update Available !</ion-text>
            <img class="pb-2" src="assets/images/transaction/transconfirm.svg" alt="img" />
            <ion-text class="maintxt text-center">{{ msg }}</ion-text>
            <div class="row w-100 pt-2">
                <div class="col">
                    <bh-button [theme]="'dark'" (click)="openAppStore()">YES</bh-button>
                </div>
                <div *ngIf="!isMajorUpdate" class="col">
                    <bh-button [theme]="'light'" (click)="closeModal()">CANCEL</bh-button>
                </div>
            </div>
        </modal-pop-up>
        <div class="w-100" [ngClass]="showTabsAndSideBar && rightPageToShowSidebar ? 'd-block' : 'd-none'">
            <bh-tabs [showTabs]="showTabsAndSideBar" [sideMenuItems]="sideMenuItems"></bh-tabs>
        </div>
    </div>
    <bh-loader *ngIf="loading"></bh-loader>
</ion-app>
